import React from 'react';
import { BiInfoCircle } from 'react-icons/bi';

import ChampDeTexte from '../../UI/ChampDeTexte/ChampDeTexte';
import CaseACocher from '../../UI/CaseACocher/CaseACocher';
import ListeDeroulante from '../../UI/ListeDeroulante/ListeDeroulante';

import S from './FrequencyInput.module.scss';

const FrequencyInput = ({ argument, onChange }) => {
  const handleOptionChange = (field, value) => {
    const newOptions = {
      ...argument.options,
      [field]: value,
    };
    onChange('options', newOptions);
  };

  const frequencyTypes = [
    { value: 'specific_date', label: 'Date spécifique' },
    { value: 'daily', label: 'Quotidien' },
    { value: 'weekly', label: 'Hebdomadaire' },
    { value: 'monthly', label: 'Mensuel' },
    { value: 'yearly', label: 'Annuel' },
    { value: 'custom', label: 'Personnalisé' },
  ];

  return (
    <div className={S.frequencyContainer}>
      <div className={S.infoBox}>
        <BiInfoCircle size={16} />
        <span>
          Ce type d'argument permet de définir une fréquence ou une date
          spécifique.
        </span>
      </div>

      <div className={S.configSection}>
        <h6 className={S.configTitle}>Configuration</h6>

        <div className={S.champGroupe}>
          <label className={S.label}>Description</label>
          <ChampDeTexte
            valeur={argument.description || ''}
            changement={(e) => onChange('description', e.target.value)}
            placeholder="Description de l'argument"
            multiline={true}
            rows={2}
          />
        </div>

        <div className={S.checkboxGroup}>
          <CaseACocher
            checked={argument.obligatoire || false}
            changement={(checked) => onChange('obligatoire', checked)}
            label="Argument obligatoire"
          />
        </div>
      </div>

      <div className={S.configSection}>
        <h6 className={S.configTitle}>Options spécifiques</h6>

        <div className={S.champGroupe}>
          <label className={S.label}>Type de fréquence par défaut</label>
          <ListeDeroulante
            valeur={argument.options?.defaultFrequencyType || 'daily'}
            changement={(value) =>
              handleOptionChange('defaultFrequencyType', value)
            }
            options={frequencyTypes}
          />
        </div>

        <div className={S.checkboxGroup}>
          <CaseACocher
            checked={argument.options?.allowSpecificDate || true}
            changement={(checked) =>
              handleOptionChange('allowSpecificDate', checked)
            }
            label="Permettre la sélection d'une date spécifique"
          />
        </div>

        <div className={S.checkboxGroup}>
          <CaseACocher
            checked={argument.options?.allowRecurring || true}
            changement={(checked) =>
              handleOptionChange('allowRecurring', checked)
            }
            label="Permettre les fréquences récurrentes"
          />
        </div>

        <div className={S.checkboxGroup}>
          <CaseACocher
            checked={argument.options?.includeTime || false}
            changement={(checked) => handleOptionChange('includeTime', checked)}
            label="Inclure l'heure (pas seulement la date)"
          />
        </div>

        <div className={S.champGroupe}>
          <label className={S.label}>Date minimum (YYYY-MM-DD)</label>
          <ChampDeTexte
            type="date"
            valeur={argument.options?.minDate || ''}
            changement={(e) => handleOptionChange('minDate', e.target.value)}
          />
        </div>

        <div className={S.champGroupe}>
          <label className={S.label}>Date maximum (YYYY-MM-DD)</label>
          <ChampDeTexte
            type="date"
            valeur={argument.options?.maxDate || ''}
            changement={(e) => handleOptionChange('maxDate', e.target.value)}
          />
        </div>
      </div>

      <div className={S.previewSection}>
        <h6 className={S.configTitle}>Aperçu de l'input utilisateur</h6>
        <div className={S.previewBox}>
          <div className={S.mockInput}>
            <div className={S.mockLabel}>
              {argument.nom || "Nom de l'argument"}
              {argument.obligatoire && <span className={S.required}>*</span>}
            </div>
            <div className={S.mockField}>
              Fréquence / Date
              {argument.options?.includeTime && ' + Heure'}
            </div>
            {argument.description && (
              <div className={S.mockDescription}>{argument.description}</div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FrequencyInput;
